import { QUESTIONNAIRE_TEMPLATE } from "../_constants/questionnaireTemplate.constant";

const initialState = {
  templateList: {
    loading: false,
    data: []
  },

}

export function questionnaireTemplateReducer(state = initialState, action) {
  switch (action.type) {
    case QUESTIONNAIRE_TEMPLATE.SET_TEMPLATE_LIST_LOADING:
      return { ...state, templateList: { ...state.templateList, loading: action.data } }
    case QUESTIONNAIRE_TEMPLATE.SET_TEMPLATE_LIST: {
      return { ...state, templateList: action.data }
    }
    case QUESTIONNAIRE_TEMPLATE.CLEAR:
      return initialState;
    default:
      return state
  }
}